/* eslint-disable implicit-arrow-linebreak */
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vue2TouchEvents from 'vue2-touch-events';



import '../public/assets/sass/main.sass';

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1000,
  easing: [1, 0, 0, 1],
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAxios, axios);

Vue.use(Vue2TouchEvents);

new Vue({
  router,
  // eslint-disable-next-line arrow-parens
  render: (h) => h(App)
}).$mount('#app');
